import type { TimeSheetEntryHistoryItemVM, TimeSheetEntryHistoryParentVM } from 'ab-viewModels/timeSheet/timeSheetEntryHistory.viewModel';

import * as TimeUtils from '@acceligentllc/shared/utils/time';

import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';

/**
 * Called only on FE when updating how items are shown on the timeline with stale data
 */
export const bulkRevertOffsetTimelineEntriesForTimeZone = (
	entries: TimeSheetEntryHistoryItemVM[],
	timeZone: Nullable<string>
): TimeSheetEntryHistoryItemVM[] => {
	if (!timeZone) {
		return entries;
	}

	const browserOffset = (new Date()).getTimezoneOffset();
	const timeZoneOffset = TimeUtils.getOffset(timeZone);

	const timeOffset = timeZoneOffset + browserOffset;

	return entries.map((_entry) => _offsetTimelineEntry(_entry, timeOffset));
};

const _offsetTimelineEntry = (entry: TimeSheetEntryHistoryItemVM, offset: number): TimeSheetEntryHistoryItemVM => {
	return {
		...entry,
		startTime: entry.startTime ? TimeUtils.offsetTime(entry.startTime, offset, 'minutes', TimeFormat.ISO_DATETIME) : null,
		endTime: entry.endTime ? TimeUtils.offsetTime(entry.endTime, offset, 'minutes', TimeFormat.ISO_DATETIME) : null,
		createdAt: TimeUtils.offsetTime(entry.createdAt, offset, 'minutes', TimeFormat.ISO_DATETIME) ?? entry.createdAt,
		deletedAt: entry.deletedAt ? TimeUtils.offsetTime(entry.deletedAt, offset, 'minutes', TimeFormat.ISO_DATETIME) : null,
		parentEntries: entry.parentEntries?.length
			? _bulkRevertOffsetTimelineParentEntriesForTimeZone(entry.parentEntries, offset)
			: null,
	};
};

/**
 * Called only on FE when updating how items are shown on the timeline with stale data
 */
const _bulkRevertOffsetTimelineParentEntriesForTimeZone = (entries: TimeSheetEntryHistoryParentVM[], offset: number): TimeSheetEntryHistoryParentVM[] => {
	if (!offset) {
		return entries;
	}

	return entries.map((_entry) => _offsetTimelineParentEntry(_entry, offset));
};

const _offsetTimelineParentEntry = (entry: TimeSheetEntryHistoryParentVM, offset: number): TimeSheetEntryHistoryParentVM => {
	return {
		...entry,
		startTime: entry.startTime ? TimeUtils.offsetTime(entry.startTime, offset, 'minutes', TimeFormat.ISO_DATETIME) : null,
		endTime: entry.endTime ? TimeUtils.offsetTime(entry.endTime, offset, 'minutes', TimeFormat.ISO_DATETIME) : null,
		createdAt: entry.createdAt ? TimeUtils.offsetTime(entry.createdAt, offset, 'minutes', TimeFormat.ISO_DATETIME) : null,
		deletedAt: entry.deletedAt ? TimeUtils.offsetTime(entry.deletedAt, offset, 'minutes', TimeFormat.ISO_DATETIME) : null,
	};
};
